import useActions from '../hooks/useActions';
import consultants from '../reducers/consultants';

export default (consultantBookings, bookingEngine) =>
  useActions({
    fetchConsultantClinicDays:
      ({ gmcCode, span, fromDate }) =>
      async dispatch => {
        const { results, consultantName } = await consultantBookings.getConsultantClinicDays({
          gmcCode,
          span,
          fromDate,
        });
        function getUniqueHospitalCodes(data) {
          return [
            ...new Set(
              data.results
                .flatMap(result => result.locations?.map(location => location.hospitalCode) || [])
                .filter(hospitalCode => hospitalCode), // Ensure no null or undefined hospitalCodes
            ),
          ];
        }
        const hospitalCodes = getUniqueHospitalCodes({ results });
        let price;
        if (results.length > 0) {
          ({ price } = await bookingEngine.getConsultantPricing({ gmcCode, hospitalCodes }));
        }
        dispatch({
          type: consultants.types.setHospitals,
          payload: results.reduce(
            (accumulator, { locations }) =>
              locations.reduce(
                (accumulator2, { hospitalId, ...hospital }) => ({
                  ...accumulator2,
                  [hospitalId]: hospital,
                }),
                accumulator,
              ),
            {},
          ),
        });

        dispatch({
          type: consultants.types.setConsultants,
          payload: {
            [gmcCode]: {
              name: consultantName,
              price,
            },
          },
        });

        dispatch({
          type: consultants.types.setClinicDays,
          payload: results.map(({ locations, ...result }) => ({
            ...result,
            locations: locations.map(({ hospitalId }) => hospitalId),
          })),
        });
      },

    clearConsultantSlots: () => async dispatch => {
      dispatch({
        type: consultants.types.setSlots,
        payload: [],
      });
    },

    fetchConsultantSlots:
      ({ gmcCode, fromDate, locations }) =>
      async dispatch => {
        const responses = await Promise.all(
          locations.map(hospitalId =>
            consultantBookings.getSlotsAvailability({
              fromDate,
              gmcCode,
              hospitalId,
            }),
          ),
        );

        dispatch({
          type: consultants.types.setSlots,
          payload: responses.reduce(
            (slots, { response: { responseData } }, index) => [
              ...slots,
              ...responseData.bookingDetails.map(slot => ({
                ...slot,
                hospitalId: locations[index],
                specialty: responseData.specialty,
              })),
            ],
            [],
          ),
        });
      },

    bookConsultantSlot:
      ({ gmcCode, ...params }) =>
      async dispatch =>
        consultantBookings.bookSlot({
          gmcCode,
          ...params,
        }),
  });
